import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder} from '../../../../lib/helpers';

export class DeleteLanguageStore implements SaveStateHolder {
  readonly languageId: number;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(languageId: number) {
    makeObservable(this);
    this.languageId = languageId;
    this.save = null;
  }

  @action
  complete = () => {
    if (this.save?.isPending === true)
      return;
    this.save = contentLoaders.x1language.delete(this.languageId);
  };
}
